import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              </div>
            )}
            {isLast ? (
              <span className="text-foreground-600 font-medium">{item.label}</span>
            ) : item.href ? (
              <Link to={item.href} className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-400">{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}